import { defineStore } from 'pinia';
import router from '@/router';
import stores from '🔗/stores';

const useNavStore = defineStore('nav', {
    state: () => ({
        basePage: null,
        page: null,
        scrollPositions: {},
        menu: [
            {
                icon: 'note',
                link: '/music',
                name: 'music',
                pages: ['music']
            }, {
                icon: 'favorite',
                link: '/favorite',
                name: 'favorite',
                pages: ['favorite', 'settings', 'favorite-artists', 'favorite-tracks', 'favorite-playlists']
            }
        ]
    }),
    getters: {
        menuItemIsActive: (state) => (name) => state.basePage === name
    },
    actions: {
        setPage(name) {
            let scrollTop = document.querySelector('.page')?.scrollTop;// window.pageYOffset || document.documentElement.scrollTop;

            if (this.page && scrollTop) {
                this.scrollPositions[this.page] = { top: scrollTop }
            }

            this.page = name;
            this.basePage = this.menu.find(item => item.name === name || item.pages.indexOf(name) !== -1)?.name || this.basePage || this.menu[0].name;
        },
        open(name, params) {
            delete this.scrollPositions[name];

            this.setPage(name);

            if (params) {
                router.push({ name, params });
            } else {
                router.push({ name });
            }


            if (stores.settings().vibration) {
                stores.others().vibrate();
            }
        },
        back() {
            const data = this.menu.find(item => item.pages.indexOf(this.page) !== -1);

            router.back(data?.name);
        },
        ready(page) {
            if (page !== this.page) {
                return;
            }

            if (this.scrollPositions[this.page]?.top) {
                document.querySelector('.page')?.scrollTo({
                    top: this.scrollPositions[this.page]?.top,
                    left: 0
                });
            }
        }
    }
});

export default useNavStore;
